import { MicrobiomeTestResult, ReportSummary } from '@snapi/types';
import { ResearchCategorySummaryUtils } from '../research-category-summary-utils';

const calculateScore = (protective: number, disruptive: number): number =>
  Math.round((protective / disruptive) * 10) / 10;

const isGood = (score: number) => score > 1;

const summary = (results: MicrobiomeTestResult[]): ReportSummary['balance'] => {
  const summary = ResearchCategorySummaryUtils.fromTestSummary(results);
  const score = calculateScore(summary.protective, summary.disruptive);

  return {
    protective: summary.protective,
    disruptive: summary.disruptive,
    neutral: summary.neutral,
    score,
    good: isGood(score),
  };
};

export const ReportGutBalanceUtils = {
  isGood,
  calculateScore,
  summary,
};
